import React from 'react';
import Box from '@mui/material/Box';
import Slider, { SliderProps } from '@mui/material/Slider';

interface MySliderProps
  extends Omit<SliderProps, 'onChange' | 'onChangeCommitted'> {
  label?: React.ReactNode;
  onChange?: (value: number | number[]) => void;
  onChangeCommitted?: (value: number | number[]) => void;
  helperText?: string;
  inputSx?: React.CSSProperties;
  subLabel?: string;
  error?: boolean;
}

const MySlider = (props: MySliderProps) => {
  const {
    value,
    onChange,
    onChangeCommitted,
    className = '',
    label = '',
    helperText = '',
    error = false,
    sx = {},
    inputSx = {},
    disabled = false,
    subLabel,
    ...otherProps
  } = props;

  const handleChange = (newValue: number | number[]) =>
    onChange && onChange(newValue);

  const handleChangeCommitted = (newValue: number | number[]) =>
    onChangeCommitted && onChangeCommitted(newValue);

  return (
    <Box className={`flex flex-col ${className}`} sx={sx}>
      <div className="mb-3 flex flex-col">
        {label && <label className="text-sm font-semibold">{label}</label>}
        {subLabel && (
          <label className={`text-xs mt-1 text-gray-600`}>{subLabel}</label>
        )}
      </div>
      <Slider
        value={value}
        onChange={(e, v) => handleChange(v)}
        onChangeCommitted={(e, v) => handleChangeCommitted(v)}
        valueLabelDisplay="auto"
        sx={{
          color: '#0050b3',
          height: 8,
          '& .MuiSlider-track': {
            border: 'none',
          },
          '& .MuiSlider-thumb': {
            height: 20,
            width: 20,
            backgroundColor: '#0050b3',
            border: '2px solid #ffffff',
            '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
              boxShadow: 'inherit',
            },
            '&:before': {
              display: 'none',
            },
          },
          '& .MuiSlider-valueLabel': {
            color: '#0050b3',
            fontSize: 14,
            padding: 0,
            fontWeight: 600,
            backgroundColor: 'transparent',
            marginTop: '50px',
          },
          ...inputSx,
        }}
        {...otherProps}
      />
      {error && helperText && (
        <span className="text-red-700 text-xs mt-2">{helperText}</span>
      )}
    </Box>
  );
};

export default MySlider;
